import script from "./QuickAccessEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickAccessEditor.vue?vue&type=script&setup=true&lang=js"

import "./QuickAccessEditor.vue?vue&type=style&index=0&id=da7290b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da7290b4"]])

export default __exports__